import { Button } from 'components/Button/Button';
import Modal from 'components/Modal/Modal';
import { useState } from 'react';
import { activateOtp } from 'services/api-otp';
import { otpProcesses } from 'utils/constants';

import EnterOtp from 'components/Otp/EnterOtp/EnterOtp';
import appHelpers from 'utils/app-urls';
import { OtpMessages } from '../messages';
import { useRefreshTokenMutation } from 'app/auth/api/auth-api';

const cdnURL = appHelpers.getCDNUrl();
const optEnabled = `${cdnURL}assets/components/icon/otp-enabled.svg `;

const EnterOtpView = ({
  sendOtp,
  onContinue,
  messages,
  phoneNumber,
  isLoading,
}: {
  sendOtp: () => void;
  onContinue: () => void;
  messages: OtpMessages;
  phoneNumber: string;
  isLoading?: boolean;
}) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [requestError, setRequestError] = useState<boolean>(false);
  const [showSuccessModal, setShowSuccessModal] = useState<boolean>(false);
  const [refreshToken] = useRefreshTokenMutation();

  const viewMessages = messages.enterOptView;

  const onChangeOtpHandler = async (value: any) => {
    if (value.length >= 6) {
      setLoading(true);
      const response: any = await activateOtp(
        value,
        otpProcesses.PROFILE_ENABLE_SMS_OTP,
      );
      if (response?.status === 200) {
        setRequestError(false);
        refreshToken();
        setShowSuccessModal(true);
        setLoading(false);
      } else {
        setRequestError(true);
        setLoading(false);
      }
    } else setRequestError(false);
  };

  const handleCompleteProcess = () => {
    setShowSuccessModal(false);
    onContinue();
  };

  const successModalContent = (
    <div className="flex justify-center items-center">
      <img src={optEnabled} alt="OTP enabled" className="w-24 lg:w-auto" />
      <div className="text-3xl text-white font-semibold ml-4">
        {viewMessages.otpEnabled}
      </div>
    </div>
  );

  const successModalFooter = (
    <div className="w-full flex justify-center mt-6">
      <Button onClick={handleCompleteProcess} main>
        {viewMessages.goToProfile}
      </Button>
    </div>
  );

  return (
    <>
      <EnterOtp
        title={viewMessages.enableOtp}
        subtitle={viewMessages.smsSent(phoneNumber)}
        onChangeOtp={onChangeOtpHandler}
        resendOtp={sendOtp}
        hasError={requestError}
        isLoading={isLoading || loading}
        type="SMS"
        process={otpProcesses.PROFILE_ENABLE_SMS_OTP}
      />
      <Modal
        show={showSuccessModal}
        content={successModalContent}
        hideModal={handleCompleteProcess}
        closeModal={handleCompleteProcess}
        hasFooter
        footer={successModalFooter}
      />
    </>
  );
};

export default EnterOtpView;
